import { Action } from 'redux';

import { SetTags } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IContentInfo } from '../models/IContentInfo';

export interface SetTagsAction extends Action {
  content: IContentInfo[];
}

export function setTags(...content: IContentInfo[]): SetTagsAction {
  return {
    type: SetTags,
    content: content
  };
}

export const isSetTagsAction = isActionFactory<SetTagsAction>(SetTags);
